import { render, staticRenderFns } from "./SettingVam.vue?vue&type=template&id=55bc53c8&scoped=true&"
import script from "./SettingVam.vue?vue&type=script&lang=js&"
export * from "./SettingVam.vue?vue&type=script&lang=js&"
import style0 from "./SettingVam.vue?vue&type=style&index=0&id=55bc53c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bc53c8",
  null
  
)

export default component.exports